import { useQuery } from 'react-query';
import { usePostCommunicationContext } from '../PostCommunicationProvider';
import { PostCommunicationContent } from '../types/postCommunicationContent';
import { queryKey } from 'constants/queryKey';
import PostApi from 'api/post';

const useHasPostVersionsTab = () => {
  const { postId, changeActiveContent, activeContent, allowedActiveContent } =
    usePostCommunicationContext();
  const firstAllowed = allowedActiveContent[0];

  const { data: postRevisions } = useQuery(
    queryKey.postRevisions({ postId }),
    () => PostApi.getPostRevisions(postId),
    {
      onSuccess: () => {
        if (postRevisions?.length) {
          return;
        }

        if (
          activeContent === PostCommunicationContent.VERSIONS &&
          firstAllowed
        ) {
          changeActiveContent(firstAllowed);
        }
      },
    },
  );

  return !!postRevisions?.length;
};

export default useHasPostVersionsTab;
